import React, { useEffect, useState } from "react";
import "./endpoint.css";
import CancelIcon from "@mui/icons-material/Cancel";
import instance from "../../ApiInstance/Inetrceptor";
import {
  Drawer,
  Grid,
  Button,
  InputLabel,
  TextField,
  Typography,
  Alert,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

const EndPointDrawer = ({
  getEndPoint,
  setIsDrawerOpen,
  isDrawerOpen,
  drawerCaller,
  setDrawerCaller,
  setBackDrop,
}) => {
  const type = drawerCaller?.name ?? "Add";
  const filledInfo = drawerCaller?.data ?? {};
  const theme = useTheme();
  const isXs = useMediaQuery(theme.breakpoints.down("xs"));
  const isSm = useMediaQuery(theme.breakpoints.between("sm", "xs"));
  const isMd = useMediaQuery(theme.breakpoints.between("md", "sm"));
  const isLg = useMediaQuery(theme.breakpoints.between("lg", "md"));
  const isXl = useMediaQuery(theme.breakpoints.up("xl"));
  let drawerWidth = "600px";
  if (isXs || window.innerWidth < 1000) {
    drawerWidth = "250px";
  } else if (isSm) {
    drawerWidth = "300px";
  } else if (isMd) {
    drawerWidth = "400px"; 
  } else if (isLg) {
    drawerWidth = "600px"; 
  } else if (isXl) {
    drawerWidth = "600px"; 
  }
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);
  const [information, setInformation] = useState({});
  const handleDrawerClose = (event) => {
    // if (event.target.id === "back-button") {
      setIsDrawerOpen(false);
    // }
  };
  const createNewEndPointApi = () => {
    const endPointType = information?.endPointType?.trim();
    const endPointDescription = information?.endPointDescription?.trim();
    if (endPointDescription.length == 0 || endPointType.length == 0) {
      setError("Please fill all mandatory fields");
      return;
    }
    const body = {
      endpoint_type_id: filledInfo?.endpoint_type_id ?? 0,
      endpoint_type_name: endPointType ?? "",
      endpoint_type_desc: endPointDescription ?? "",
    };
    setBackDrop(true);
    instance
      .post("api/v1/Master/EndpointType/Post", body)
      .then((res) => {
        if (res?.data?.Success) {
          setError(null);
          setSuccess(res?.data?.ResultMessage);
          getEndPoint();
          setTimeout(() => {
            setSuccess(null);
          }, 5000);
        } else {
          setError(res?.data?.ResultMessage);
          setTimeout(() => {
            setError(null);
          }, 5000);
        }
        if(type === "Add")
        {
        setDrawerCaller({
          endpoint_type_name:"",
          endpoint_type_desc:""
        })
      }
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        setBackDrop(false);
      });
  };
  useEffect(() => {
    setInformation({
      endPointType: filledInfo?.endpoint_type_name ?? "",
      endPointDescription: filledInfo?.endpoint_type_desc ?? "",
    });
  }, [drawerCaller]);

  return (
    <Drawer
      anchor="right"
      open={isDrawerOpen}
      //   onClose={handleDrawerClose}
      PaperProps={{
        sx: {
          width: drawerWidth, // Set the width dynamically
        },
      }}
    >
      <div
        style={{ padding: "20px" }}
        // onClick={handleDrawerClose}
        // onKeyDown={handleDrawerClose}
      >
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <Button
              id="back-button"
              variant="contained"
              color="transparent"
              className="button_backEndpoint"
              onClick={handleDrawerClose}
              startIcon={<ArrowBackIcon  onClick={handleDrawerClose}/>}
            >
              Back
            </Button>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h5"
              className="font-colorEndpoint mb-0"
              style={{ fontWeight: "600" }}
            >
              {type == "Add" ? "Add " : "Edit"} Endpoint Type{" "}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <Typography
              variant="h7"
              className="font-colorEndpoint mb-1"
              style={{ fontWeight: "600" }}
            >
               Endpoint Type Information{" "}
            </Typography>
          </Grid>
          {/* alert */}
          <Grid item xs={12}>
            {error && (
              <Alert
                variant="outlined"
                severity="error"
                icon={
                  <CancelIcon
                    onClick={() => setError(null)}
                    style={{ cursor: "pointer" }}
                  />
                }
                className="errorAlertMaintain mt-4"
              >
                {error}
              </Alert>
            )}
            {success && (
              <Alert
                variant="outlined"
                severity="success"
                className="sucessAlertMaintain mt-4"
              >
                {success}
              </Alert>
            )}
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="entity-name">Endpoint Type<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              id="entity-name"
              size="small"
              variant="outlined"
              fullWidth
              value={information?.endPointType}
              onChange={(event) => {
                console.log(event.target.value, "informatoin");
                setInformation((prev) => {
                  return {
                    ...prev,
                    endPointType: event.target.value,
                  };
                });
              }}
            />
          </Grid>
          <Grid item xs={12}>
            <InputLabel htmlFor="entity-name">Description<span style={{ color: "red" }}>*</span></InputLabel>
            <TextField
              id="entity-name"
              size="small"
              multiline
              rows={4}
              variant="outlined"
              fullWidth
              value={information?.endPointDescription}
              onChange={(event) => {
                console.log(event.target.value, "informatoin");
                setInformation((prev) => {
                  return {
                    ...prev,
                    endPointDescription: event.target.value,
                  };
                });
              }}
            />
          </Grid>
          <Grid item xs={12} sx={{ textAlign: "right" }}>
            <Button
              id="back-button"
              variant="contained"
              color="secondary"
              onClick={() => {
                createNewEndPointApi();
              }}
            >
              {type == "Add" ? "Create" : "Save Changes"}
            </Button>
          </Grid>
        </Grid>
      </div>
    </Drawer>
  );
};

export default EndPointDrawer;
